import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/assets'
import Component from 'components/Assets/Select'

export default createListModalContainer({ actions })(Component)
